export default "__VITE_ASSET__CjPLl9ZC__"